import Configs from '@/config/Configs';

export class NewsletterService {
  /**
   * Get the current newsletter subscriber count
   * @returns Promise<number> The subscriber count
   */
  static async getSubscriberCount(): Promise<number> {
    try {
      // For now, return the configured value
      // In the future, this could be enhanced to fetch from LinkedIn API
      return Promise.resolve(Configs.NEWSLETTER.SUBSCRIBER_COUNT);
    } catch (error) {
      console.error('Error fetching subscriber count:', error);
      // Return a default fallback number that when multiplied will give us the fallback
      return 1000; // This * comics will be formatted as fallback
    }
  }

  /**
   * Get fallback laughs value when calculation fails
   * @returns string The fallback display value
   */
  static getFallbackLaughs(): string {
    return Configs.NEWSLETTER.FALLBACK_LAUGHS;
  }
}